import React from 'react';

export default function CategoryGrid({ categories = [] }) {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h2 className="text-xl font-semibold mb-4">Categories</h2>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
        {categories.map((c) => (
          <a key={c.id || c.slug} href={`/category/${c.slug}`} className="block border rounded p-3 hover:bg-gray-50">
            <div className="font-medium">{c.name}</div>
            <div className="text-xs text-gray-500">{c.description}</div>
          </a>
        ))}
      </div>
    </div>
  );
}
